import CustomButton from "../../../../components/CustomButton";
import userRoles from "../../../../constants/userRoles";
import { pickingRoutes } from "../../../../router/routesConstants";
import usePermissions from "../../../../router/usePermissions";
import Text from "../../../../styleguide/Text";

function VerificationZonesCustomHeader() {
  const { isAuthorized } = usePermissions();

  const goToCreateVerificationZone = () => {
    return `/${pickingRoutes.picking}/${pickingRoutes.verificationZones}/${pickingRoutes.createVerificationZone}`;
  };

  return (
    <div className="flex justify-between items-center mb-6">
      <Text
        variant="h3"
        component="h3"
        className="font-semibold text-slate-900">
        Zone de verificare
      </Text>
      {isAuthorized(userRoles.EDIT_VERIFICATION_ZONE) && (
        <CustomButton
          variant="contained"
          icon="ADD"
          tooltipTitle="Creeaza zona de verificare"
          navigate={goToCreateVerificationZone()}>
          Creeaza zona de verificare
        </CustomButton>
      )}
    </div>
  );
}

export default VerificationZonesCustomHeader;
